import * as React from 'react';
import { renderDrawerBody_unstable } from '@fluentui/react-drawer';
import { useCustomStyleHook_unstable } from '@fluentui/react-shared-contexts';
import { useNavDrawerBody_unstable } from './useNavDrawerBody';
import { useNavDrawerBodyStyles_unstable } from './useNavDrawerBodyStyles.styles';
/**
 * NavDrawerBody component
 */ export const NavDrawerBody = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useNavDrawerBody_unstable(props, ref);
    useNavDrawerBodyStyles_unstable(state);
    useCustomStyleHook_unstable('useNavDrawerBodyStyles_unstable')(state);
    return renderDrawerBody_unstable(state);
});
NavDrawerBody.displayName = 'NavDrawerBody';
